import { Injectable } from "@angular/core";
import { Http, Headers, Response } from "@angular/http";
import * as crypto from 'crypto-js';
import { Observable } from "rxjs/Observable";
import { environment } from "../../../environments/environment";
import { ApiUrlConstants } from "../../common/constants/api.constants";
import { NexioRegistration } from "../interface/nexiopayment/nexio-registration.interface";
import { PaymentRegistrationResponse } from "../interface/payvision/payment-registration-reponse.interface";


@Injectable()
export class NexioService {
    constructor(private _http: Http) { }
    

    getPaymentForm(storeId: number, paymentRegistrationRequest: NexioRegistration)
    : Observable<PaymentRegistrationResponse> {
    const headers = this.getPaymentHeaders();
    return this._http
        .post(decodeURIComponent(encodeURIComponent(ApiUrlConstants.paymentApiUrl + 'payments/store/' + storeId +
        '/payment-checkout-form ')), paymentRegistrationRequest, { headers: headers })
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
}

/**
 * @description this is used to get payment headers
 * @returns {Headers}
 * @memberof NIService
 */
getPaymentHeaders(): Headers {
    const headers = new Headers();
    const authHeader = 'PAY ' + environment.paymentApiKey + ':' + this.getHashedValue();
    headers.append('authorization', authHeader);
    return headers;
}

/**
 * @description this method is used to get payment crypto hashed value
 * @returns {string}
 * @memberof NIService
 */
getHashedValue(): string {
    const shavalue = crypto.HmacSHA1(environment.paymentSecurityKey, environment.paymentServiceKey);
    return crypto.enc.Base64.stringify(shavalue);
}

saveTokenResponse(resposeRequest: any, memberId: any,sourceID: number, storeID: any) {
    let url = 'payments/nexio/notification?saveCard=true&orderSourceTypeId=' + sourceID +'&storeID='+ storeID ;
    if(memberId && memberId > 0){
        url = url + '&customerID='+memberId;
    }
    const headers = this.getPaymentHeaders();
    return this._http
        .post(ApiUrlConstants.paymentApiUrl + url, resposeRequest, { headers: headers })
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable)
}

/**
* To handle the obervable error response
* @param  {Response|any} error
*/
private handleErrorObservable(error: Response | any) {
    return Observable.throw(error);
}
}


// WEBPACK FOOTER //
// ./src/app/customerservice/services/nexio.service.ts